export * from "@vaadin/text-area/vaadin-text-area.js";
export * from './generated/TextArea.js';
